// Cookie read by every *.crowncoinscasino.com surface (dev router, backend, game-ui)
// to route requests to the debug env — same name the value used to ride as a header.
export const DEBUG_ENV_COOKIE = 'x-debug';
export const GEO_HEADER = 'cf-ipcountry';

// localStorage keys (non-cookie state).
export const LS_GEO = 'debug-geo';
export const LS_INDICATOR = 'debug-indicator';

// PR deploy cookies routing a per-PR build. admin_pr is intentionally omitted:
// the admin app is a separate surface (admin.dev.crowncoinscasino.com) and not
// routed from the player frontend.
export const PR_COOKIES: { name: string }[] = [{ name: 'player_pr' }, { name: 'securepay_pr' }, { name: 'game_pr' }];

// Slug must match the dev Caddy regex: first char a letter, then [a-z0-9], 4–31 chars.
export const SLUG_REGEX = /^[a-z][a-z0-9]{3,30}$/;

// Geo override options ('' = Off → no header).
export const GEO_OPTIONS: { label: string; value: string }[] = [
  { label: 'Off', value: '' },
  { label: 'USA', value: 'US' },
  { label: 'NZ', value: 'NZ' },
  { label: 'Canada', value: 'CA' },
  { label: 'Germany', value: 'DE' },
  { label: 'Austria', value: 'AT' },
];
